import { getUnitCountAnimalChart } from '../helpers';
import { getWeightUnit, roundWeight, stockingPhaseTypes, weightUnits } from '../../../config/commons';

import { horizontalChartTypes } from './helper';
import { groupLabels } from './math_percentile';
import { Analysis, TypeHorizontalChart } from './interfaces';

export const getHorizontalBarChartData = (props: {typeChart: TypeHorizontalChart; analysisData: Analysis; }) => {
  const { typeChart, analysisData } = props;

  let data: number[] = [];
  let ranges: number[] = [];
  let percents: string[] = [];
  let averageWeight = 0;
  let weightLabels: string[] = [];

  const larvaeNumber = analysisData.resultData.larvaeNumber;
  const analysisPhaseType = analysisData.phaseType;
  
  let measureUnit = getUnitCountAnimalChart(analysisPhaseType);

  const isConsolidatedGrowOut = analysisData.phaseType === stockingPhaseTypes.ADULT && analysisData?.analysisIds?.length > 0;

  const countGroup = analysisData.resultData.countGroup;
  const weightGroup = analysisData.resultData.weightGroup;

  if (typeChart === horizontalChartTypes.SHRIMPS_PER_GROUP) {
    percents = countGroup.map(value => ((value * 100) / larvaeNumber).toFixed(1));
    data = countGroup;
  } else if (typeChart === horizontalChartTypes.CUMMULATIVE_WEIGHT_PER_GROUP) {
    data = weightGroup.map(group => Math.round(group));
    const totalWeight = data.reduce((total, value) => total + value, 0);

    percents = data.map(group => ((group * 100) / totalWeight).toFixed(1));
    measureUnit = weightUnits.MG;
  }

  ranges = analysisData.resultData.labels;
  averageWeight = analysisData.resultData.averageWeight;

  ranges = roundWeight({ value: ranges, showUnit: false, average: averageWeight }) as number[];

  if (measureUnit !== 'pl' && measureUnit !== 'ind') {
    measureUnit = getWeightUnit(averageWeight);
    data = roundWeight({ value: data, showUnit: false, average: averageWeight }) as number[];
  }

  weightLabels = groupLabels(ranges);

  return {
    data,
    weightLabels,
    measureUnit,
    percents,
    averageWeight,
    isConsolidatedGrowOut,
  };
};

export const getHorizontalBarChartOriginalData = (props: {typeChart: TypeHorizontalChart; analysisData: Analysis; measureUnit: string; }) => {
  const { typeChart, analysisData, measureUnit } = props;

  let data: number[] = [];

  const isSieving = analysisData.isSieved || false;
  const originalResultData = analysisData.originalResultData;

  if (!isSieving || !originalResultData) {
    return {
      originalData: [],
    };
  }

  const countGroup = originalResultData.countGroup;
  const weightGroup = originalResultData.weightGroup;

  if (typeChart === horizontalChartTypes.SHRIMPS_PER_GROUP) {
    data = countGroup;
  } else if (typeChart === horizontalChartTypes.CUMMULATIVE_WEIGHT_PER_GROUP) {
    data = weightGroup.map(group => Math.round(group));
  }

  if (measureUnit !== 'pl' && measureUnit !== 'ind') {
    data = roundWeight({ value: data, showUnit: false, average: analysisData.resultData.averageWeight }) as number[];
  }

  return {
    originalData: data,
  };
};